import React from 'react';
import { AnchorProps } from './Anchor.types';

export const AnchorComponent: React.FC<AnchorProps> = ({ model }) => {
  return <div id={model?.textId} />;
};
